export const breakpoints = {
  mobile: 320,
  tablet: 660,
  desktop: 960,
};
